// extracted by mini-css-extract-plugin
export var hidden = "_p5-1";
export var visible = "_p5-0";